module.exports = __webpack_public_path__ + "img/hover_icon_dispense_management.bc2a5011.svg";